import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import useScrollTrigger from '@mui/material/useScrollTrigger';
import useIsMobile from 'hooks/useIsMobile';
import React from 'react';

interface SectionHeaderInterface {
  text: string;
  button: React.ReactNode | null;
}

interface ElevationScrollInterface {
  children: React.ReactElement<any>;
}

const ElevationScroll: React.FC<ElevationScrollInterface> = ({ children }) => {
  const { isMobile } = useIsMobile();

  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 0,
  });

  return React.cloneElement(children, {
    elevation: trigger && isMobile ? 4 : 0,
  });
};

const SectionHeader: React.FC<SectionHeaderInterface> = ({ text, button }) => (
  <ElevationScroll>
    <AppBar
      sx={{
        backgroundColor: '#F9FAFD',
        zIndex: '1',
        position: { lg: 'static' },
      }}
    >
      <Toolbar
        sx={{
          pt: { xs: '18px', xl: 5 },
          pb: { xs: '20px', xl: 5 },
          pl: { xs: '65px', lg: '0 !important' },
          pr: { xl: '0 !important' },
          minHeight: { xs: '80px', xl: '138px' },
          display: 'flex',
          justifyContent: { xs: 'start', lg: 'space-between' },
          alignItems: 'center',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            width: { xs: '100%', lg: 'auto' },
            justifyContent: 'space-between',
            ml: 2,
          }}
        >
          {text !== '' && (
            <Typography
              variant="h4"
              sx={{
                color: '#000',
                mr: { xs: 2, lg: 6 },
                ml: 1,
              }}
            >
              {text}
            </Typography>
          )}
          {button}
        </Box>
        <Box sx={{ display: { xs: 'none', lg: 'flex' }, justifyContent: 'flex-end' }}>
          <Typography
            variant="h6"
            sx={{
              color: '#000',
            }}
          >
            {new Date().toLocaleDateString('es-CL')}
          </Typography>
        </Box>
      </Toolbar>
    </AppBar>
  </ElevationScroll>
);

export default SectionHeader;
